import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62dca25c")

_pushScopeId("data-v-62dca25c")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加音频")
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("更新上线")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("上线")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("下线")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_radio_menu_audio_dialog = _resolveComponent("radio-menu-audio-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "success",
        onClick: _ctx.switchOnlineVersion
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.isShowOnlineVersion ? '返回' : '查看线上版本'), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_2,
      (!_ctx.isShowOnlineVersion)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            onClick: _ctx.addAudio
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.audios,
      stripe: "",
      style: {"width":"100%"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "audio",
          label: "音频"
        }, {
          default: _withId((scope) => [
            (scope.row.audio)
              ? (_openBlock(), _createBlock("audio", {
                  key: 0,
                  src: scope.row.audio,
                  controls: ""
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "sortNumber",
          width: "80px",
          label: "排序"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lightBackground",
          label: "浅色背景图"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_image, {
              class: "image",
              src: scope.row.lightBackground
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "darkBackground",
          label: "深色背景图"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_image, {
              class: "image",
              src: scope.row.darkBackground
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "fileSize",
          label: "大小",
          width: "80"
        }, {
          default: _withId((scope) => [
            _createVNode("div", null, _toDisplayString(scope.row.fileSize ? `${(scope.row.fileSize / 1024 / 1024).toFixed(2)}M` : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作"
        }, {
          default: _withId(({row}) => [
            _createVNode("div", _hoisted_4, [
              (!_ctx.isShowOnlineVersion)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    size: "small",
                    class: "margin-right-10",
                    onClick: ($event: any) => (_ctx.editAudio(row)),
                    type: "warning"
                  }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.isShowOnlineVersion && row.latestOnlineVersion !== undefined && row.latestOnlineVersion !== row.latestVersion)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    size: "small",
                    class: "margin-right-10",
                    onClick: ($event: any) => (_ctx.onlineAudio(row)),
                    type: "success"
                  }, {
                    default: _withId(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.isShowOnlineVersion && row.latestOnlineVersion === undefined)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    size: "small",
                    class: "margin-right-10",
                    onClick: ($event: any) => (_ctx.onlineAudio(row)),
                    type: "success"
                  }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              ((row.latestOnlineVersion !== undefined) || _ctx.isShowOnlineVersion)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    size: "small",
                    class: "margin-right-10",
                    onClick: ($event: any) => (_ctx.offlineAudio(row)),
                    type: "info"
                  }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.isShowOnlineVersion && row.latestOnlineVersion === undefined)
                ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                    key: 4,
                    onConfirm: ($event: any) => (_ctx.deleteAudio(row)),
                    title: "确定删除吗？"
                  }, {
                    reference: _withId(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "danger"
                      }, {
                        default: _withId(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_radio_menu_audio_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = $event)),
      menuId: _ctx.radioMenuId,
      audio: _ctx.currentAudioToEdit,
      onSuccess: _ctx.handleMenuAudioUpdate
    }, null, 8, ["modelValue", "menuId", "audio", "onSuccess"])
  ], 64))
})